import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  IShopCurrency,
  IShopProductVariant,
  IShopProductVariation,
} from '@x/ecommerce/shop-client';

@Component({
  selector: 'x-product-price',
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'x-product-price',
  },
})
export class ProductPriceComponent {
  @Input() price: IShopCurrency | undefined;
  @Input() product: { variation: IShopProductVariation; variants: IShopProductVariant[] };
}
